import { render, staticRenderFns } from "./PurchaseJourney.vue?vue&type=template&id=d57294dc&scoped=true&lang=pug"
import script from "./PurchaseJourney.js?vue&type=script&lang=js&external"
export * from "./PurchaseJourney.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57294dc",
  null
  
)

export default component.exports